import * as _api2 from "@shapediver/api.geometry-api-dto-v2";
var _api = _api2;
try {
  if ("default" in _api2) _api = _api2.default;
} catch (e) {}
import * as _sdk2 from "@shapediver/sdk.geometry-api-sdk-core";
var _sdk = _sdk2;
try {
  if ("default" in _sdk2) _sdk = _sdk2.default;
} catch (e) {}
import _ShapeDiverErrors from "./ShapeDiverErrors";
import _ShapeDiverSdk from "./ShapeDiverSdk";
import _utils from "./utils/utils";
var exports = {};
var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = exports && exports.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGBResponseError = exports.isGBRequestError = exports.isGBGenericError = exports.isGBError = exports.create = exports.ShapeDiverSdk = exports.ShapeDiverResponseError = exports.ShapeDiverSdkConfigType = exports.ShapeDiverSdkApiResponseType = exports.ShapeDiverRequestError = exports.ShapeDiverError = void 0;
__exportStar(_api, exports);
var sdk_geometry_api_sdk_core_1 = _sdk;
Object.defineProperty(exports, "ShapeDiverError", {
  enumerable: true,
  get: function () {
    return sdk_geometry_api_sdk_core_1.ShapeDiverError;
  }
});
Object.defineProperty(exports, "ShapeDiverRequestError", {
  enumerable: true,
  get: function () {
    return sdk_geometry_api_sdk_core_1.ShapeDiverRequestError;
  }
});
Object.defineProperty(exports, "ShapeDiverSdkApiResponseType", {
  enumerable: true,
  get: function () {
    return sdk_geometry_api_sdk_core_1.ShapeDiverSdkApiResponseType;
  }
});
Object.defineProperty(exports, "ShapeDiverSdkConfigType", {
  enumerable: true,
  get: function () {
    return sdk_geometry_api_sdk_core_1.ShapeDiverSdkConfigType;
  }
});
var ShapeDiverErrors_1 = _ShapeDiverErrors;
Object.defineProperty(exports, "ShapeDiverResponseError", {
  enumerable: true,
  get: function () {
    return ShapeDiverErrors_1.ShapeDiverResponseError;
  }
});
var ShapeDiverSdk_1 = _ShapeDiverSdk;
Object.defineProperty(exports, "ShapeDiverSdk", {
  enumerable: true,
  get: function () {
    return ShapeDiverSdk_1.ShapeDiverSdk;
  }
});
Object.defineProperty(exports, "create", {
  enumerable: true,
  get: function () {
    return ShapeDiverSdk_1.create;
  }
});
var utils_1 = _utils;
Object.defineProperty(exports, "isGBError", {
  enumerable: true,
  get: function () {
    return utils_1.isGBError;
  }
});
Object.defineProperty(exports, "isGBGenericError", {
  enumerable: true,
  get: function () {
    return utils_1.isGBGenericError;
  }
});
Object.defineProperty(exports, "isGBRequestError", {
  enumerable: true,
  get: function () {
    return utils_1.isGBRequestError;
  }
});
Object.defineProperty(exports, "isGBResponseError", {
  enumerable: true,
  get: function () {
    return utils_1.isGBResponseError;
  }
});
//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule,
  isGBResponseError = exports.isGBResponseError,
  isGBRequestError = exports.isGBRequestError,
  isGBGenericError = exports.isGBGenericError,
  isGBError = exports.isGBError,
  create = exports.create,
  ShapeDiverSdk = exports.ShapeDiverSdk,
  ShapeDiverResponseError = exports.ShapeDiverResponseError,
  ShapeDiverSdkConfigType = exports.ShapeDiverSdkConfigType,
  ShapeDiverSdkApiResponseType = exports.ShapeDiverSdkApiResponseType,
  ShapeDiverRequestError = exports.ShapeDiverRequestError,
  ShapeDiverError = exports.ShapeDiverError;